<template>
  <v-app style="background: linear-gradient(180deg, rgba(7,7,7,1) 67%, rgba(166,6,0,1) 100%);">
    <v-main>
      <HelloWorld />
    </v-main>
  </v-app>
</template>

<script>
import HelloWorld from "./components/HelloWorld";

export default {
  name: "App",

  components: {
    HelloWorld,
  },

  data: () => ({
    //
  }),
};
</script>
